import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from "@angular/forms";
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { AccountsgroupService } from "../shared/accountsgroup.service";

@Component({
  selector: 'app-accountsgrouplist',
  templateUrl: './accountsgrouplist.component.html',
  styleUrls: ['./accountsgrouplist.component.css']
})
export class AccountsgrouplistComponent implements OnInit {

  displayedColumns: string[] = ['Id', 'AccountId', 'AccountName', 'DisplayIn', 'GroupCode', 'SubGroup', 'New'];
  dataSource = new MatTableDataSource<any>();
 @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(private router: Router, private accountsgroupService: AccountsgroupService) { }

  ngOnInit() {
    this.dataSource.paginator = this.paginator;
    this.FetchVoucherList();
  }

  FetchVoucherList() {
    this.accountsgroupService.FetchVoucherList()
      .toPromise()
      .then(data => {
        console.log(data);
        this.dataSource.data = data;
      })
  }
  
  public AddNew() {
    this.router.navigate(['/accountsgroup']);
  }

  Edit(accountsgroup: any) {
    this.router.navigate(['/accountsgroup', accountsgroup.Id]);
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

}
